import { render, staticRenderFns } from "./taskstage.vue?vue&type=template&id=ea6c94cc&scoped=true&"
import script from "./taskstage.vue?vue&type=script&lang=js&"
export * from "./taskstage.vue?vue&type=script&lang=js&"
import style0 from "./taskstage.vue?vue&type=style&index=0&id=ea6c94cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea6c94cc",
  null
  
)

export default component.exports